module.exports = __webpack_public_path__ + "img/duplicate.b0636fdc.svg";